module.exports = __webpack_public_path__ + "static/media/PaymentLoyaltyScreen.08a09e2a.png";